import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AgencyCreatorHeaderList } from './AgencyCreatorHeaderList';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { setDeselectInfluencer } from '../../../store/agency/agencySlice';
import { CustomImageHandler } from '../../../shared/components/CustomImageHandler';
import { useNavigate } from 'react-router-dom';
import { InternalRoutes } from '../../../enum/InternalRoutes';
import { FindAgencyCreatorsModal } from './FindAgencyCreatorsModal';
import { truncateString } from '../../../shared/functions/Functions';
import TooltipOverlay from '../../../shared/components/tooltip/Tooltip';

export function AgencyHeader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { selectedInfluencer } = useSelector((state: IAllStates) => state.agency);
    const [showModal, setShowModal] = useState(false);
    const isMobile = window.innerWidth <= 700;

    const influencerName = selectedInfluencer?.displayName
        ? selectedInfluencer.displayName
        : `${selectedInfluencer?.firstName ?? ''} ${selectedInfluencer?.lastName ?? ''}`.trim();
    const displayedName = isMobile ? truncateString(influencerName, 20) : influencerName;
    const isNameTruncated = isMobile && influencerName.length > 20;

    const deselectUser = () => {
        dispatch(setDeselectInfluencer());
    };

    const navigateTo = (path: string) => {
        navigate(path);
    };

    const navigateToInfluencerProfile = () => {
        navigate(`${InternalRoutes.INFLUENCER_PROFILE_EDIT}/${selectedInfluencer?.id}`);
        localStorage.setItem('selectedAgencyCreator', `${selectedInfluencer?.id}`);
    };

    return (
        <>
            <FindAgencyCreatorsModal show={showModal} closeModal={() => setShowModal(false)} />
            <div className="agency-header d-flex justify-content-between align-items-center">
                {selectedInfluencer?.id ? (
                    <div className="d-flex align-items-center col-auto col-md-2 px-0">
                        <CustomImageHandler
                            classes="user-placeholder"
                            photoPath={selectedInfluencer?.profilePhoto?.thumbnail ?? ''}
                            thumbnailPath={selectedInfluencer?.profilePhoto?.thumbnail ?? ''}
                            altTag="User Profile"
                            name={
                                !!selectedInfluencer.displayName
                                    ? selectedInfluencer.displayName
                                    : selectedInfluencer.firstName + ' ' + selectedInfluencer.lastName
                            }
                        />
                        <div className="ml-2">
                            <TooltipOverlay content={isNameTruncated ? influencerName : ''}>
                                <h6 className="mb-1">{displayedName}</h6>
                            </TooltipOverlay>
                            <p onClick={navigateToInfluencerProfile} className="mb-0 text-primary cursor-pointer">
                                {t('agency.influencers.edit_profile')}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="col-2 px-0" />
                )}
                <div className="d-none d-md-flex" style={{ paddingLeft: 64 }}>
                    <div
                        onClick={deselectUser}
                        className={`agency-filter-rounded-img mr-2 ${
                            selectedInfluencer?.id ? 'bg-white' : 'bg-primary'
                        }`}
                    >
                        <strong className={`mb-0 ${selectedInfluencer?.id ? 'text-primary' : 'text-white'}`}>
                            ALL
                        </strong>
                    </div>
                    <AgencyCreatorHeaderList />
                    <div onClick={() => setShowModal(true)} className="agency-filter-rounded-img">
                        <img src="/icons/img-search.png" alt="search" />
                    </div>
                </div>
                <div className="col-2 px-0 d-flex justify-content-end">
                    <Button
                        onClick={() => navigateTo(InternalRoutes.AGENCY_CAMPAIGNS)}
                        className="d-none d-md-flex"
                        variant="outline-primary"
                        size="sm"
                    >
                        {t('agency.see_all_camp')}
                    </Button>
                </div>
                <div className="d-flex d-md-none align-items-center">
                    <div
                        onClick={deselectUser}
                        className={`d-flex d-md-none mr-4 agency-filter-rounded-img mr-2 ${
                            selectedInfluencer?.id ? 'bg-white' : 'bg-primary'
                        }`}
                    >
                        <strong className={`mb-0 ${selectedInfluencer?.id ? 'text-primary' : 'text-white'}`}>
                            ALL
                        </strong>
                    </div>
                    <img
                        onClick={() => setShowModal(true)}
                        src="/icons/change-agency-influencer.svg"
                        className="d-flex d-md-none"
                        alt="agency-influencer"
                    />
                </div>
            </div>
        </>
    );
}
